import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ModalService} from '../../../shared/modals/modal/modal.service';
import {BookService} from '../../../services/public/book.service';
import {BookModel} from '../../../models/edu-admin/book.model';
import {BookVersionModel} from '../../../models/edu-admin/book-version.model';
import {UserModel} from '../../../models/authentication/user.model';
import {TranslateService} from '@ngx-translate/core';
import {ChargebeeService} from '../../../services/student/chargebee.service';

@Component({
  selector: 'app-payment-confirmation',
  templateUrl: './payment-confirmation.component.html',
  styleUrls: ['./payment-confirmation.component.css']
})
export class PaymentConfirmationComponent implements OnInit {

  orderId: string = null;

  subscription: string;

  book: BookModel;
  bookVersion: BookVersionModel;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private cbSv: ChargebeeService,
              private bookSv: BookService,
              private modalSv: ModalService,
              private tSv: TranslateService) { }

  ngOnInit() {

    if (UserModel.getCurrent()) {
      if (this.tSv.currentLang !== UserModel.getCurrent().culture) {
        this.tSv.use(UserModel.getCurrent().culture);
      }
    }


    this.route.queryParams.subscribe((params) => {

      this.subscription = params.subscription;

      if (this.subscription !== 'trial') {
        this.cbSv.updateStudentSubscriptionStatus().subscribe((student) => {

        });
      }

    });

  }


  onNextClicked() {
    this.router.navigate(['gameintro'], { queryParams: { subscription: this.subscription } });
  }

}
